import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { swalSuccess } from '../../common/components/Swaler'

import useQuery from '../../hooks/useQuery'

const pollMapping = {
  dc: 'Din avvikelse har bekräftats', // deviationConfirmed
  da: 'Din avvikelse har godkänts', // deviationApproved
}

const Poll = ({ match }) => {
  const { poll } = match.params
  const query = useQuery()
  const [comment, setComment] = useState('')

  const id = query.get('id')

  useEffect(() => {
    if (id) axios.post('/subject/customer/polls', { poll, packageId: id })
  }, [id])

  const updatePollData = () => {
    axios.put('/subject/customer/polls', { comment, poll, packageId: id })
    swalSuccess('Skickat', '', 'OK')
  }

  return (
    <div style={{ paddingLeft: 40 }}>
      <div>{pollMapping[poll]}</div>

      <div>Vill du ange ytterligare information?</div>
      <textarea cols="30" rows="10" placeholder="Kommentar" value={comment} onChange={(e) => setComment(e.target.value)} />
      <button onClick={updatePollData}>Skicka</button>
    </div>
  )
}

export default Poll
